import React from 'react';
import { useSelector } from 'react-redux';
import { selectAppSettings } from 'store/reducers/appSettings/appSettings.slice';
import { Box, Typography } from '@mui/material';
import { Button, useTheme } from '@manulife/mux';
import { Conversation, Phone } from '@manulife/mux-cds-icons';
import { paths } from 'constants';

const DefaultInfo = () => {
  const theme = useTheme();
  const styles = setStyles(theme);
  const { contact, contactHours, chatbotLOB } = useSelector(selectAppSettings);

  //hide chatbot in mfa screens
  const showChatBot = () => {
    const currentPath = window.location.pathname;
    if (chatbotLOB && !currentPath.includes(paths.CUSC_MFA)) {
      return true;
    }
    return false;
  };

  return (
    <Box>
      <Box sx={styles.section}>
        <Typography sx={styles.header}>If you need assistance</Typography>
      </Box>
      {showChatBot() && (
        <Box sx={styles.section}>
          <Box sx={styles.headerContainer}>
            <Box style={styles.chatbotBg}>
              <Conversation style={styles.chatbotIcon} />
            </Box>
            <Typography sx={styles.header}>
              Chat with virtual assistant:
            </Typography>
          </Box>
          <Typography sx={styles.content}>
            Click the chat bubble icon and ask the virtual assistant for help.
          </Typography>
        </Box>
      )}
      <Box sx={styles.section}>
        <Box sx={styles.headerContainer}>
          <Phone style={styles.contactIcon} />
          <Typography sx={styles.header}>Contact:</Typography>
        </Box>
        <Typography sx={styles.content}>
          Call <strong>{contact}</strong> {contactHours}
        </Typography>
      </Box>
      <hr style={styles.separator} />
      <Typography sx={styles.subcontent}>
        <strong>Please note: </strong> inactive sessions will close after 15
        minutes and any unsaved data could be lost. Access and use of this
        website is for authorized users only.
      </Typography>
    </Box>
  );
};

const setStyles = (theme) => {
  return {
    section: {
      marginBottom: '30px',
    },
    headerContainer: {
      display: 'flex',
      gap: '5px',
    },
    header: {
      fontSize: '1.25rem',
      fontWeight: '600',
      textAlign: 'left',
    },
    content: {
      marginTop: '10px',
      marginLeft: '30px',
    },
    chatbotBg: {
      width: '24px',
      height: '24px',
      borderRadius: '12px',
      backgroundColor: theme.button.variant[Button.VARIANT.PRIMARY].bg,
      fontSize: '0.9rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    chatbotIcon: {
      color: 'white',
    },
    contactIcon: {
      padding: '2.5px',
      height: '20px',
      width: '20px',
    },
    separator: {
      marginTop: '30px',
      marginBottom: '30px',
    },
    subcontent: {
      fontSize: '0.875rem',
      letterSpacing: 0,
    },
  };
};

export default DefaultInfo;
